import { useSelector } from 'react-redux'
import { HeartButton, ProductPrice, ProductQuantityInput, validateProductInStock } from '@ten24/slatwall-storefront-react-private/global'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getBrandRoute, getProductRoute, getVerifiedAccountFlag } from '@ten24/slatwall-storefront-react-private/global'
import { useState } from 'react'
import { isAuthenticated } from '@ten24/slatwall-storefront-react-private/global'
import { ProductOutOfStock } from '../ProductOutOfStock/ProductOutOfStock'
import ProductCardImage from './ProductCardImage'
import { ListingButtons } from './ListingButtons'

const SkuCard = (props) => {
  const {
    cardConfiguration,
    productName,
    productCode,
    salePrice,
    urlTitle,
    brandName,
    brandUrlTitle,
    listPrice,
    productClearance,
    skuID = "",
    skuCode,
    settings,
    product_productDescription,
    cardType = 'Basic'
  } = props;
  
  const { t } = useTranslation()
  const [isFetching, setFetching] = useState(false)
  const [itemCount, setItemCount] = useState(1)
  const brand = useSelector(getBrandRoute)

  const product = useSelector(getProductRoute)
  const productLink = `/${product}/${urlTitle}` + (skuID.length ? `?skuid=${skuID}` : '')
  const isProductInStock = !isFetching && validateProductInStock(props)

  if (!cardConfiguration) {
    console.log('Missing Configuration')
    return null
  }
  return (
    <>
      {cardType === "Basic" &&
        <div className="card skuCard p-3 pt-2 h-100">
          {productClearance === true && <span className="badge">{t('frontend.core.special')}</span>}
          <HeartButton skuID={skuID} />
          <Link to={productLink}>
            <ProductCardImage product={props} />
          </Link>
          <div className="card-body">
            {cardConfiguration?.showBrand && (
              <Link to={`/${brand}/${brandUrlTitle}`} className="text-capitalize mb-3" style={{ fontSize: 12 }}>
                {brandName}
              </Link>
            )}
            <h2>
              <Link to={productLink} className="product-name d-inline-block w-100">
                {productName}
              </Link>
            </h2>
            {cardConfiguration.showProductCode && productCode && <div className="product-brand">{productCode}</div>}
            {cardConfiguration.showSkuCode && skuCode && <div className="product-brand">{skuCode}</div>}
            {cardConfiguration?.showPrice && <ProductPrice salePrice={salePrice} listPrice={listPrice} ShowPriceForUserType={settings?.skuShowPriceForUserType} className="d-flex" />}
          </div>

          <ProductOutOfStock isFetching={isFetching} sku={props} />
          <CardProductQuantityInput skuSettings={settings} cardConfiguration={cardConfiguration} isProductInStock={isProductInStock} setQuantity={setItemCount} quantity={itemCount} sku={props} stock={props.calculatedQATS || props.stocks_calculatedQATS} />
          <ListingButtons skuSettings={settings} cardConfiguration={cardConfiguration} isProductInStock={isProductInStock} productLink={productLink} isFetching={isFetching} skuID={skuID} itemCount={itemCount} setFetching={setFetching} setItemCount={setItemCount} />
        </div>
      }

      {cardType === "Image Fill" &&
        <div className="card skuCard h-100">
          {productClearance === true && <span className="badge">{t('frontend.core.special')}</span>}
          <HeartButton skuID={skuID} />
          <Link to={productLink} className="position-relative">
            <div className='position-absolute top-0 h-auto w-100 text-center' style={{ backgroundColor: "rgba(255,255,255,0.5)", color: "black" }}>
              <p className="fw-bold px-2">
                {productName}
              </p>
            </div>
            <ProductCardImage product={props} />
            <div className='position-absolute bottom-0 h-auto w-100 text-center' style={{ backgroundColor: "rgba(255,255,255,0.5)", color: "black" }}>
              <p className="fw-bold px-2 d-flex justify-content-center align-items-center">
                <ProductPrice salePrice={salePrice} listPrice={listPrice} ShowPriceForUserType={settings?.skuShowPriceForUserType} className="d-flex" />
                <span className='ms-1'>
                  Incl. tax
                </span>
              </p>
            </div>
          </Link>
        </div>
      }

      {cardType === "Full width Description Card" &&
        <div className="card skuCard h-100 d-flex flex-row col-12 flex-wrap justify-content-center" >
          {productClearance === true && <span className="badge">{t('frontend.core.special')}</span>}
          <HeartButton skuID={skuID} />
          <Link to={productLink} style={{ maxHeight: "250px", maxWidth: "250px" }} className="col-12 col-lg-3 justify-content-center">
            <ProductCardImage product={props} />
          </Link>
          <div className="card-body col-lg-9 col-12" >
            <h2>
              <Link to={productLink} className="product-name d-inline-block w-100">
                <b>{productName}</b>
              </Link>
            </h2>
            <div dangerouslySetInnerHTML={{
              __html: product_productDescription,
            }} />
            <span>
              <Link to={productLink} className="product-name d-inline-block w-100 mt-2">
                <b>More about {productName + " >"} </b>
              </Link>
            </span>
          </div>
        </div>
      }

      {cardType === "Third width Description Card" &&
        <div className="card skuCard third-desc-skucard h-100 d-flex flex-row col-lg-4 col-12 flex-wrap justify-content-center align-content-start">
          {productClearance === true && <span className="badge">{t('frontend.core.special')}</span>}
          <HeartButton skuID={skuID} />
          <Link to={productLink} style={{ maxHeight: "250px", maxWidth: "250px" }} className="col-12 justify-content-center">
            <ProductCardImage product={props} />
          </Link>
          <div className="card-body col-12" >
            <h2>
              <Link to={productLink} className="product-name d-inline-block w-100">
                <b>{productName}</b>
              </Link>
            </h2>
            <div dangerouslySetInnerHTML={{
              __html: product_productDescription,
            }} style={{ maxHeight: "140px", overflowY: "scroll" }} />
            <span>
              <Link to={productLink} className="product-name d-inline-block w-100 mt-2">
                <b>More about {productName + " >"} </b>
              </Link>
            </span>
          </div>
        </div>
      }
    </>



  )
}

const CardProductQuantityInput = ({ cardConfiguration, isProductInStock, skuSettings, ...props }) => {
  const isVerifiedAccount = useSelector(getVerifiedAccountFlag)
  const isAuthenticatedUser = isAuthenticated()
  const authenticationRequiredForAddToCart = !!skuSettings?.skuRequireLoginToAddToCart ? isAuthenticatedUser : true
  let criteriaPassed = false
  if (cardConfiguration.input.showCriteria === 'all') criteriaPassed = true
  if (cardConfiguration.input.showCriteria === 'showForAuthenticatedUsers') criteriaPassed = isAuthenticatedUser
  if (cardConfiguration.input.showCriteria === 'showForAuthenticatedUsersAndInStock') criteriaPassed = isAuthenticatedUser && isProductInStock
  if (cardConfiguration.input.showCriteria === 'showForVerifiedUsers') criteriaPassed = isVerifiedAccount
  if (cardConfiguration.input.showCriteria === 'showForVerifiedUsersAndInStock') criteriaPassed = isVerifiedAccount && isProductInStock
  if (!criteriaPassed || !authenticationRequiredForAddToCart) return null
  
  return (
    <div className="text-center border-0 bg-transparent pt-0 ">
      <div
        style={{
          margin: '0 auto',
          width: '5em',
        }}
      >
        <ProductQuantityInput showLabel={cardConfiguration?.showInputLabel} {...props} />
      </div>
    </div>
  )
}

const AuthenticateRequiredMessage = () => {
  const { t } = useTranslation()
  return (
    <div className="alert alert-warning fs-6" role="alert">
      {t('frontend.product.loginToAdd')}
      <br />
      <Link to="/my-account/login"> {t('frontend.account.login')} </Link>
    </div>
  )
}



const ProductCard = props => {
  const { cardConfiguration, productName, productCode, salePrice, urlTitle, brandName, brandUrlTitle, listPrice, productClearance, skuID = '', skuCode, settings } = props
  const { t } = useTranslation()
  const [isFetching, setFetching] = useState(false)
  const [itemCount, setItemCount] = useState(1)
  // const dispatch = useDispatch()
  // const [, setSkuID] = useState(skuID)
  // const [showModal, setModal] = useState(false)

  const brand = useSelector(getBrandRoute)
  const product = useSelector(getProductRoute)
  const productLink = `/${product}/${urlTitle}` + (skuID.length ? `?skuid=${skuID}` : '')
  if (!cardConfiguration) {
    console.log('Missing Configuration')
    return null
  }

  return (
    <div className="card productCard p-3 pt-2 h-100">
      {productClearance === true && <span className="badge">{t('frontend.core.special')}</span>}
      <HeartButton skuID={skuID} />
      <Link to={productLink}>
        <ProductCardImage product={props} />
      </Link>
      <div className="card-body">
        {cardConfiguration?.showBrand && (
          <Link to={`/${brand}/${brandUrlTitle}`} className="text-capitalize mb-3" style={{ fontSize: 12 }}>
            {brandName}
          </Link>
        )}
        <h2>
          <Link to={productLink} className="product-name d-inline-block w-100">
            {productName}
          </Link>
        </h2>
        {cardConfiguration.showProductCode && productCode && <div className="product-brand">{productCode}</div>}
        {cardConfiguration.showSkuCode && skuCode && <div className="product-brand">{skuCode}</div>}
        {cardConfiguration?.showPrice && <ProductPrice salePrice={salePrice} listPrice={listPrice} ShowPriceForUserType={settings?.skuShowPriceForUserType} className="d-flex" />}
      </div>
      <ProductOutOfStock isFetching={isFetching} sku={props} />
      <CardProductQuantityInput skuSettings={settings} cardConfiguration={cardConfiguration} isProductInStock={true} setQuantity={setItemCount} quantity={itemCount} sku={props} stock={props.calculatedQATS || props.stocks_calculatedQATS} />
      <ListingButtons skuSettings={settings} cardConfiguration={cardConfiguration} isProductInStock={true} productLink={productLink} isFetching={isFetching} skuID={skuID} itemCount={itemCount} setFetching={setFetching} setItemCount={setItemCount} />
    </div>
  )
}

export { ProductCard, SkuCard, AuthenticateRequiredMessage, CardProductQuantityInput }
